import React, { useContext } from 'react';

import Inputs from 'components/Inputs';
import FeatureGatesContext from 'contexts/FeatureGatesContext';
import V5GadgetFormContext from 'contexts/V5GadgetFormContext';

import Label from '../Label';
import { InputWrapper } from '../styles';

// A matrix with a secondary row dimension: each dimension A value as a
// collapsible row with its subtotals, its secondary rows under it. Only
// DataTable draws it, so it's only offered on dataTable-gated accounts
const StackSecondaryRowsInput = () => {
  const { isDataTableEnabled } = useContext(FeatureGatesContext);
  const {
    draftChart,
    secondaryDimensionA,
    isSecondaryRowsStacked,
    setIsSecondaryRowsStacked,
  } = useContext(V5GadgetFormContext);

  if (
    !isDataTableEnabled ||
    !draftChart ||
    draftChart.gadgetType !== 'matrix' ||
    !secondaryDimensionA
  ) {
    return null;
  }

  return (
    <InputWrapper>
      <Label>Stack secondary rows</Label>
      <Inputs.Toggle
        value={!!isSecondaryRowsStacked}
        onChange={setIsSecondaryRowsStacked}
        testId="stack-secondary-rows"
      />
    </InputWrapper>
  );
};

export default StackSecondaryRowsInput;
